$(() => {
    // Job filter
    $('#FilterMore').on('click', function () {
        $('#FilterMoreBlock').toggleClass('d-flex')
        document.querySelectorAll('.filter-block').forEach(item => item.classList.add('d-none'))
    })

    // Oe mobile
    $('#DescriptionJob').on('click', function () {
        $('#DescriptionJobBlock').toggleClass('d-none')
        $('#DescriptionJob i.fa-chevron-up').toggleClass('fa-chevron-down')
        $('#DescriptionJob i.fa-chevron-down').toggleClass('fa-chevron-up')
    })

    $('#MissionsJob').on('click', function () {
        $('#MissionsJobBlock').toggleClass('d-none')
        $('#MissionsJob i.fa-chevron-up').toggleClass('fa-chevron-down')
        $('#MissionsJob i.fa-chevron-down').toggleClass('fa-chevron-up')
    })

    $('#ProfileJob').on('click', function () {
        $('#ProfileJobBlock').toggleClass('d-none')
        $('#ProfileJob i.fa-chevron-up').toggleClass('fa-chevron-down')
        $('#ProfileJob i.fa-chevron-down').toggleClass('fa-chevron-up')
    })

    $('#AdditionalInformationsJob').on('click', function () {
        $('#AdditionalInformationsJobBlock').toggleClass('d-none')
        $('#AdditionalInformationsJob i.fa-chevron-up').toggleClass('fa-chevron-down')
        $('#AdditionalInformationsJob i.fa-chevron-down').toggleClass('fa-chevron-up')
    })

    // Applicant profile
    $('#EditAdvancedLink').on('click', function () {
        toggleChevron('EditAdvancedLink ~ i', 'EditAdvancedBlock')
    })

    // ApplicantFilter
    $('#FilterProfileLink').on('click', function () {
        toggleChevron('FilterProfileLink i', 'FilterProfileBlock')
    })

    $('#FilterAlertLink').on('click', function () {
        toggleChevron('FilterAlertLink i', 'FilterAlertBlock')
    })

    $('#Job').on('change', function () {
        $('.job-details').addClass('d-none')
        if (this.value) {
            $('#jobDetails-' + this.value).removeClass('d-none')
        }
    })

    // see more
    document.querySelectorAll('.toggle-text').forEach(function (button) {
        button.addEventListener('click', function () {
            const cardBody = this.closest('.see-more')
            const shortText = cardBody.querySelector('.short-text')
            const fullText = cardBody.querySelector('.full-text')

            if (shortText.classList.contains('d-none')) {
                // Afficher le texte court
                shortText.classList.remove('d-none')
                fullText.classList.add('d-none')
                this.textContent = 'Voir plus'
            } else {
                // Afficher le texte complet
                shortText.classList.add('d-none')
                fullText.classList.remove('d-none')
                this.textContent = 'Voir moins'
            }
        })
    })
})

function toggleChevron(icon, idBlock) {
    $('#' + icon).toggleClass('fa-chevron-down')
    $('#' + icon).toggleClass('fa-chevron-up')

    if (idBlock) {
        $('#' + idBlock).toggleClass('d-none')
    }
}
